export default __webpack_public_path__ + "images/ad-placeholder.jpg?4928d14";